import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { DozentFaq } from '../../../services/dozent.service';
import { Tutor } from '../../../services/tutor.service';

@Component({
  selector: 'app-faq-dialog',
  templateUrl: './faq-dialog.component.html',
  styleUrl: './faq-dialog.component.scss',
})
export class FaqDialogComponent implements OnInit {
  @Input() faq: Partial<DozentFaq> | null = null;
  @Input() tutors: Tutor[] = [];
  @Input() courses: any[] = [];
  @Input() categories: string[] = [];
  @Input() onConfirm: (faq: Partial<DozentFaq>) => void = () => {};

  model: Partial<DozentFaq> = {
    question: '',
    answer: '',
    category: 'general',
    version: '1.0',
    is_active: true,
    dozent_bot_ids: [],
  };

  showCustomCategory = false;
  customCategory = '';

  defaultCategories = [
    'general',
    'course',
    'exam',
    'organization',
    'technical',
    'other',
  ];

  get isEdit(): boolean {
    return !!this.faq?.id;
  }

  constructor(
    protected dialogRef: NbDialogRef<FaqDialogComponent>,
    private t: TranslateService
  ) {}

  ngOnInit() {
    if (this.faq) {
      this.model = { ...this.faq };
      if (!this.model.dozent_bot_ids) {
        this.model.dozent_bot_ids = [];
      }
    }
    if (!this.categories || this.categories.length === 0) {
      this.categories = [...this.defaultCategories];
    }
  }

  get allCategories(): string[] {
    return [...this.categories, '__custom__'];
  }

  getCategoryLabel(cat: string): string {
    if (cat === '__custom__') {
      return this.t.instant('pages.dozent.faqs.customCategory');
    }
    const key = `pages.dozent.faqs.categories.${cat}`;
    const translated = this.t.instant(key);
    return translated !== key ? translated : cat;
  }

  onCategoryChange(value: string) {
    if (value === '__custom__') {
      this.showCustomCategory = true;
      this.model.category = '';
    } else {
      this.showCustomCategory = false;
      this.customCategory = '';
      this.model.category = value;
    }
  }

  submit() {
    if (!this.model.question || !this.model.answer) return;
    // Multi-select requires ≥1 dozent — the API rejects empty arrays
    // as 400, so we mirror that constraint client-side rather than
    // letting the request fail.
    if (!this.model.dozent_bot_ids || this.model.dozent_bot_ids.length === 0) {
      return;
    }
    if (this.showCustomCategory && this.customCategory.trim()) {
      this.model.category = this.customCategory.trim().toLowerCase();
    }
    this.onConfirm(this.model);
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }
}
